import React, { createContext, useContext } from 'react';
import vendorConfig, { isWhitelabel, vendorId } from '../vendors/vendorConfig';

const VendorContext = createContext(null);

export function VendorProvider({ children }) {
  const value = {
    config: vendorConfig,
    isWhitelabel,
    vendorId,
    branding: vendorConfig.branding,
    features: vendorConfig.features,
    links: vendorConfig.links,
    auth: vendorConfig.auth,
    agency: vendorConfig.agency,
    theme: vendorConfig.theme,
    isFeatureEnabled: (featureName) => vendorConfig.features[featureName] !== false,
  };

  return (
    <VendorContext.Provider value={value}>
      {children}
    </VendorContext.Provider>
  );
}

export function useVendor() {
  const context = useContext(VendorContext);
  if (!context) {
    throw new Error('useVendor must be used within a VendorProvider');
  }
  return context;
}

export default VendorContext;
